import React from 'react';
import { defineMessages } from 'react-intl-next';

import PersonAvatarIcon from '@atlaskit/icon/core/person';

import { useContentCreator } from '../hooks/useContentCreator';

import { PersonRow } from './PersonRow';

const i18n = defineMessages({
	creator: {
		id: 'details-panel.properties-section.creator-row',
		defaultMessage: 'Creator',
		description: "A title that accompanies the content creator's avatar and display name",
	},
	accessibleAvatarLabel: {
		id: 'details-panel.properties-section.creator-row.accessible-avatar-label',
		defaultMessage: '{displayName}’s profile picture',
		description: "Alt text and aria-label for a user's profile picture",
	},
});

export const CreatorRow = () => {
	const { data, error, refetch, loading } = useContentCreator();

	return (
		<PersonRow
			loadingTestId="creator-row-loading"
			icon={<PersonAvatarIcon label="" />}
			analyticsRole="creator"
			i18n={{ accessibleAvatarLabel: i18n.accessibleAvatarLabel, personLabel: i18n.creator }}
			data={data}
			error={error}
			refetch={refetch}
			loading={loading}
		/>
	);
};
